import { MOSTRAR_AREAS, LOADING_AREAS, AREAS_FAILED } from "./../types";
import { api_base, api_basev2 } from "../../config";
import { getData } from "./../../utils/api-client";

export const getAreasOrganizacionales = () => async dispatch => {

    let url = api_base + "api/v1/areas";

    let urlv2 = api_basev2 + `AreasOrganizacionales/ObtenerAreas`;
    await getData
        .get(urlv2)
        .then(resultado => {
            dispatch({ type: LOADING_AREAS });
            dispatch({ type: MOSTRAR_AREAS, payload: resultado.data.data });
            
            // //console.log(resultado.data);
        })
        .catch(error => {
            if (error) {
                dispatch({ type: AREAS_FAILED });
            } else {
                window.location.reload();
            }
        });
};

export const getAreasOrganizacionalesResponsables = (areaOrganizacionalId) => async dispatch => {

    let url = api_base + "api/v1/areasResponsables";
    let urlv2 = api_basev2 + `AreasOrganizacionales/AreasResponsables?id=${areaOrganizacionalId}`
    await getData
    .get(urlv2)
    .then(resultado => {
        dispatch({ type: LOADING_AREAS });
        dispatch({ type: MOSTRAR_AREAS, payload: resultado.data.data });
    })
    .catch(error => {
        if (error.response) {
            dispatch({ type: AREAS_FAILED });
        } else {
            window.location.reload();
        }
    });
};